import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselSettingsFn = /* @__PURE__ */ createRecipe('carousel-settings', {}, [])

const carouselSettingsVariantMap = {}

const carouselSettingsVariantKeys = Object.keys(carouselSettingsVariantMap)

export const carouselSettings = /* @__PURE__ */ Object.assign(memo(carouselSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselSettings',
  __getCompoundVariantCss__: carouselSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselSettingsVariantKeys,
  variantMap: carouselSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselSettingsVariantKeys)
  },
  getVariantProps: carouselSettingsFn.getVariantProps,
})